import { render } from "./cardViewTvEpisode.vue?vue&type=template&id=2a2fb088"
import script from "./cardViewTvEpisode.vue?vue&type=script&lang=js"
export * from "./cardViewTvEpisode.vue?vue&type=script&lang=js"

import exportComponent from "F:\\Project Coustomer\\vue film\\film\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__